var map = {
	"./staging_holiday_promo.json": [
		21980,
		1980
	],
	"./staging_holiday_promo_23d.json": [
		26676,
		6676
	],
	"./staging_holiday_promo_3.json": [
		71235,
		1235
	],
	"./staging_waitlist.json": [
		4722,
		4722
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 45594;
module.exports = webpackAsyncContext;